/*
 * Enables AJAX loading of posts
 *
 * @author BarrelNY
 *
 */
var AjaxPagination = {
	init:function(){
		var templates = [
			'body.progress-page'
		].join();

		if (!$(templates).length) return;

		// var ajax_url & posts_per_page
		// assigned at top of progress-page.php
		var Gallery = require('../global/gallery.js');
		var page = 2;

		$(function($) {
			$('body').on('click', '.load-more', function() {
    		var that = $(this);

				if ( that.data('requestRunning') ) {
					return;
				}

				that.data('requestRunning', true);

				$.ajax({
					url: admin_ajax.url,
					type: 'POST',
					data: {
						page: page,
						action: 'load_posts_by_ajax',
						posts_per_page: MUR.posts_per_page
					},
					error: function(response) {
						console.log('Error: ' + response);
					},
					success: function(response) {
						$('.ajax-wrapper').append(response);
						Gallery.rebuild();
						page++;

						if (page >= MUR.max_num_pages) {
							$('.load-btn').hide();
						}
					},
					complete: function() {
						that.data('requestRunning', false);
					}
				});
			});
		})
	}
}

module.exports = AjaxPagination;

